module.exports = __webpack_public_path__ + "img/bg-th1.febff8f1.png";